import { MultiSelectField, Option } from 'components/Forms/MultiSelectField';
import type { ReactNode } from 'react';
import { CustomOption } from './recipientSelectorCustomComponent';
import { ReportDropdownIndicator, reportDropdownIndicatorStyles } from './reportDropdownIndicator';

interface Props {
  recipientOptions: Option[];
  recipientsSelected: Option[];
  setRecipientsSelected: (options: Option[]) => void;
  recipientsLabel: ReactNode;
}

const ReportOptions = ({
  recipientOptions,
  recipientsSelected,
  setRecipientsSelected,
  recipientsLabel,
}: Props) => (
  <div className="report-options-recipients-selector">
    <label htmlFor="recipient-select">{recipientsLabel}</label>
    <MultiSelectField
      id="recipient-select"
      name="recipients_selected"
      placeholder="Filter By"
      options={recipientOptions}
      styles={{
        ...reportDropdownIndicatorStyles,
        control: provided => ({
          ...provided,
          maxHeight: '36px',
        }),
        menuList: provided => ({
          ...provided,
          backgroundColor: 'transparent !important',
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor:
            state.isSelected || (!state.isSelected && !state.isFocused)
              ? 'transparent !important'
              : 'inherit',
        }),
      }}
      handleChange={setRecipientsSelected}
      closeMenuOnSelect={true}
      hideSelectedOptions={false}
      value={recipientsSelected}
      customOption={CustomOption}
      customComponents={{ DropdownIndicator: ReportDropdownIndicator }}
    />
  </div>
);

export default ReportOptions;
